import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { AccountMergeDataset } from './account.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.Contractor,
})
export class ContractorMergeDataset extends AccountMergeDataset {
}